import React, { useEffect, useState, useCallback, useMemo } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/system";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

const CustomToggle = React.memo(({ options, selectedValue, onChange }) => {
    const [selectedOption, setSelectedOption] = useState(
        selectedValue || options[0]
    );
    const { getContainerHeight, getFontSize } = useResponsiveStyles();

    const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
        "& .MuiToggleButton-root": {
            ...getContainerHeight("filter-height"),
            ...getFontSize("body1"),
            padding: "8px 16px",
            color: "#525E6F",
            textTransform: "capitalize",
            border: "none",
            borderRadius: "8px",
            "&.Mui-selected": {
                color: "#231F20",
                backgroundColor: "#ffff",
                border: "1px solid #B6C1CA",
                zIndex: 1,
            },
        },
    }));

    const handleToggleChange = useCallback(
        (event, newOption) => {
            if (newOption !== null) {
                setSelectedOption(newOption);
                if (onChange) onChange(newOption);
            }
        },
        [onChange]
    );

    useEffect(() => {
        setSelectedOption(selectedValue);
    }, [selectedValue]);

    const renderedOptions = useMemo(
        () =>
            options.map((option) => (
                <ToggleButton key={option} value={option}>
                    {option}
                </ToggleButton>
            )),
        [options]
    );

    return (
        <div
            style={{
                borderRadius: "8px",
                backgroundColor: "#F6F7F9",
                border: "1px solid #B6C1CA",
            }}
        >
            <StyledToggleButtonGroup
                value={selectedOption}
                exclusive
                onChange={handleToggleChange}
            >
                {renderedOptions}
            </StyledToggleButtonGroup>
        </div>
    );
});

export default CustomToggle;
